module.exports = __webpack_public_path__ + "static/media/190-Mobile-Banner@2x.e6804243.jpg";